import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import {
  INTENT_PROJECT_SUCCESS_MESSAGES,
  REFETCH_INTENT_PROJECT_AND_ATTACHABLE_INTEGRATIONS_QUERIES,
} from "../constants";
import { DETACH_AWS_INTEGRATION_FROM_INTENT_PROJECT } from "./gql";

const useDetachIntegration = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const [detachMutation, { loading, error }] = useMutation(
    DETACH_AWS_INTEGRATION_FROM_INTENT_PROJECT,
    {
      refetchQueries: REFETCH_INTENT_PROJECT_AND_ATTACHABLE_INTEGRATIONS_QUERIES,
      awaitRefetchQueries: true,
    }
  );

  const detachIntegration = useCallback(
    async (input: { intentProjectId: string; integrationId: string }) => {
      try {
        await detachMutation({
          variables: {
            intentProject: input.intentProjectId,
            integration: input.integrationId,
          },
        });

        reportSuccess({ message: INTENT_PROJECT_SUCCESS_MESSAGES.INTEGRATION_DETACHED });
      } catch (error) {
        onError(error);
      }
    },
    [detachMutation, onError, reportSuccess]
  );

  return {
    detachIntegration,
    loading,
    error,
  };
};

export default useDetachIntegration;
